const ImageComparisonBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#ffd400" d="M12 2H2v20h10V2z" />
    <path d="M0 0v24h24V0zm22 22H2V2h20z" fill="#333" />
    <path fill="#fff" d="M12 12v10h10V2H12v10z" />
    <path fill="#333" d="M8 14h8v-4H8v4z" />
  </svg>
);

export default ImageComparisonBlockIcon;
